import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import { UserProvider } from './useContext/UserProvider';
import 'react-modern-drawer/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@trustvid/design-system/styles.css';
import App from './App';

import { registerGlobalErrorHandlers } from "./utils/GlobalErrorHandler";
import { initGtm } from "./utils/gtm";

initGtm();
registerGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <BrowserRouter>
      <Provider store={store}>
         <UserProvider>
         <App />
         </UserProvider>
      </Provider>
   </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
